import { Link, useLocation } from "react-router-dom";
import { Texts, Media } from "../../Object/";
import Nav from "./Nav";
import { useRef, useEffect, useMemo, useState } from "react";
import { useToggle, useOffsetTop, useScroll } from "../../Hooks";

const Header = () => {
  const location = useLocation();
  const headerRef = useRef(null);
  const { pageOffsetTop, viewportTop } = useOffsetTop(headerRef);
  const [active, setActive] = useState(false); // ファーストビューからスクロール後にactive化
  const [open, toggleOpen] = useToggle(false);
  const scrollPosition = useScroll();

  const border = useMemo(() => {
    // 位置を取得できなかったときは最大サイズとして表示
    if (pageOffsetTop > 800) {
      setActive(true);
    } else {
      if(location.pathname == '/') {
        setActive(false);
      }
    }
    // 位置に応じてサイズ計算
  }, [pageOffsetTop, viewportTop]);
  
  useEffect(() => {
    if (open) {
      toggleOpen(false);
    }
    
    let path = location.pathname.replace('/', '');
    path = path.split('/');

    if(path[0] !== '') {
      setActive(true);
    } else {
      if(scrollPosition > window.innerHeight) {
        setActive(true);
      } else {
        setActive(false);
      }
    }
  }, [location, scrollPosition]);
  
  return (
    <>

      <Link className="l-header__img--logo__link sp" to="/">
        <Media
          src="common/icon-logo"
          alt="icon-logo"
          class="l-header__img--logo"
        ></Media>
      </Link>
      <header
        ref={headerRef}
        className={
          active || open ? "l-header__wrap l-header__wrap--active" : "l-header__wrap"
        }
      >
        <div className="l-header__wrap--inner">
          <Link className="l-header__img--logo__link pc" to="/">
            <Media
              src="common/icon-logo"
              alt="icon-logo"
              class="l-header__img--logo"
            ></Media>
          </Link>
          <Nav
            remove={[]}
            position="header"
            open={open}
            toggleOpen={toggleOpen}
          />
        </div>
      </header>

      <button className="l-header__button" onClick={() => toggleOpen()}>
        <Media src="common/icon-menu" alt="menu"></Media>
      </button>
    </>
  );
};

export default Header;
